// Overgezet uit naslag/server/server/generateData/tasksPerCategory/Veiligheid.ts.
import { TaskType } from '../../types/tasks.js';
import { Asset } from '../../types/assets.js';
import { InGameEffect } from '../../types/inGameEffect.js';
import { SparePart } from '../../types/storage.js';
const effect = (asset) => [
    {
        type: InGameEffect.diceRed,
        description: 'Vervang een incident resultaat van de risico randomizer',
        asset,
    },
];
export const VeiligheidsTaken = [
    {
        _id: 'veiligheid0',
        type: TaskType.veiligheid,
        title: 'Incident Preventie',
        cost: 1000,
        description: 'Plaats omkasting om de dosseerder, om letsel te voorkomen',
        inGameEffectDescription: 'Vervang een incident resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceRed],
        needsSparepart: true,
        sparepartNeeded: SparePart.meelDoseerder,
        needsMechanic: true,
        levelMechanicNeeded: 4,
        specificAsset: Asset.mixer,
        taskEffects: effect(Asset.mixer),
    },
    {
        _id: 'veiligheid1',
        type: TaskType.veiligheid,
        title: 'Incident Preventie',
        cost: 1000,
        description: 'Plaats een nieuwe wals met beknellingsbeveiliging',
        inGameEffectDescription: 'Vervang een incident resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceRed],
        needsSparepart: true,
        sparepartNeeded: SparePart.deegwals,
        needsMechanic: false,
        specificAsset: Asset.vormmachineA,
        taskEffects: effect(Asset.vormmachineA),
    },
    {
        _id: 'veiligheid2',
        type: TaskType.veiligheid,
        title: 'Incident Preventie',
        cost: 1000,
        description: 'Plaats een nieuwe wals met beknellingsbeveiliging',
        inGameEffectDescription: 'Vervang een incident resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceRed],
        needsSparepart: true,
        sparepartNeeded: SparePart.deegwals,
        needsMechanic: false,
        specificAsset: Asset.vormmachineB,
        taskEffects: effect(Asset.vormmachineB),
    },
    {
        _id: 'veiligheid3',
        type: TaskType.veiligheid,
        title: 'Incident Preventie',
        cost: 1500,
        description: 'Plaats een verwarmingselement met overspanningsbeveiliging',
        inGameEffectDescription: 'Vervang een incident resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceRed],
        needsSparepart: true,
        sparepartNeeded: SparePart.verwarmingselement,
        needsMechanic: true,
        levelMechanicNeeded: 2,
        specificAsset: Asset.oven,
        taskEffects: effect(Asset.oven),
    },
    {
        _id: 'veiligheid4',
        type: TaskType.veiligheid,
        title: 'Incident Preventie',
        cost: 1500,
        description: 'Vervang poreuze slangen preventief. Koelmiddel kan hierdoorheen lekken',
        inGameEffectDescription: 'Vervang een incident resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceRed],
        needsSparepart: false,
        needsMechanic: false,
        specificAsset: Asset.koeler,
        taskEffects: effect(Asset.koeler),
    },
    {
        _id: 'veiligheid5',
        type: TaskType.veiligheid,
        title: 'Incident Preventie',
        cost: 1500,
        description: 'Een verouderde gripper kan ertoe leiden dat de dozen koekjes gaan rondvliegen, vervang deze preventief',
        inGameEffectDescription: 'Vervang een incident resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceRed],
        needsSparepart: true,
        sparepartNeeded: SparePart.vacuumGripper,
        needsMechanic: false,
        specificAsset: Asset.inpakker,
        taskEffects: effect(Asset.inpakker),
    },
    {
        _id: 'veiligheid6',
        type: TaskType.veiligheid,
        title: 'Incident Preventie',
        cost: 2000,
        description: 'Plaast een snelheidsbegrenzer op de mixer, om doldraaien te voorkomen',
        inGameEffectDescription: 'Vervang een incident resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceRed],
        needsSparepart: false,
        needsMechanic: false,
        specificAsset: Asset.mixer,
        taskEffects: effect(Asset.mixer),
    },
    {
        _id: 'veiligheid7',
        type: TaskType.veiligheid,
        title: 'Incident Preventie',
        cost: 3000,
        description: 'Plaats een nieuwe aandrijving, de as van de bestaande is gescheurd en kan leiden tot rondvliegend metaal',
        inGameEffectDescription: 'Vervang een incident resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceRed],
        needsSparepart: true,
        sparepartNeeded: SparePart.aandrijving,
        needsMechanic: false,
        specificAsset: Asset.vormmachineB,
        taskEffects: effect(Asset.vormmachineB),
    },
    {
        _id: 'veiligheid8',
        type: TaskType.veiligheid,
        title: 'Incident Preventie',
        cost: 5000,
        description: 'Vervang de filters. Door verstopping van de filters bouwt de druk op met explosiegevaar tot gevolg.',
        inGameEffectDescription: 'Vervang een incident resultaat van de risico randomizer',
        inGameEffect: [InGameEffect.diceRed],
        needsSparepart: true,
        sparepartNeeded: SparePart.luchtfilters,
        needsMechanic: false,
        specificAsset: Asset.koeler,
        taskEffects: effect(Asset.koeler),
    },
];
